import PropTypes from 'prop-types';
import { InputAdornment, TextField, Switch, FormControlLabel, Autocomplete } from '@mui/material';
import { CurrencyRupee } from '@mui/icons-material';
import { Body3, H5 } from '../../../../../../../themes/typography';

export default function TicketBasicDetail({
    formik,
    isEditModeOn,
    exceedStatusEditable,
    qtyEditable,
    gstRates
}) {
    return (
        <div className="ticket-pricing-container">
            <div className="ticket-name-details-container" style={{ alignSelf: 'stretch' }}>
                <TextField
                    required
                    fullWidth
                    type="text"
                    id="ticketName"
                    name="ticketName"
                    label="Ticket Name"
                    placeholder="Enter ticket name"
                    value={formik.values.ticketName}
                    disabled={!isEditModeOn}
                    onChange={(e) => formik.setFieldValue('ticketName', e.target.value)}
                    error={formik.touched.ticketName && Boolean(formik.errors.ticketName)}
                    helperText={formik.touched.ticketName && formik.errors.ticketName}
                />
            </div>
            <div className="ticket-price-quantity-container">
                <div className="ticket-name-details-container">
                    <TextField
                        id="ticketQty"
                        name="ticketQty"
                        label="Ticket Quantity"
                        value={formik.values.qty}
                        inputMode="numeric"
                        type="text"
                        disabled={!qtyEditable}
                        onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, '');
                            formik.setFieldValue('qty', value);
                        }}
                        error={formik.touched.qty && Boolean(formik.errors.qty)}
                        helperText={formik.touched.qty && formik.errors.qty}
                    />
                </div>
                <div className="ticket-name-details-container">
                    <TextField
                        id="ticketPrice"
                        name="ticketPrice"
                        label="Ticket Price"
                        inputMode="numeric"
                        type="text"
                        value={formik.values.price}
                        placeholder="0"
                        disabled={!isEditModeOn}
                        onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9.]/g, '');
                            formik.setFieldValue('price', value);
                        }}
                        slotProps={{ input: { startAdornment: <PriceIcon /> } }}
                        error={formik.touched.price && Boolean(formik.errors.price)}
                        helperText={formik.touched.price && formik.errors.price}
                    />
                </div>
            </div>

            <div className="ticket-exceed-gst-parent-container">
                <div className="ticket-exceed-gst">
                    <div className="ticket-exceed-gst-container">
                        <H5 fontWeight={500}>Exceed Total Ticket Quantity?</H5>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                            <div className="ticket-name-details-container">
                                <FormControlLabel
                                    onChange={(e) =>
                                        formik.setFieldValue('exceedTicketQty', e.target.checked)
                                    }
                                    checked={formik.values.exceedTicketQty}
                                    disabled={!exceedStatusEditable}
                                    control={<Switch color="main" id="exceedTicketQtySwitch" />}
                                    label={formik.values.exceedTicketQty ? 'Yes' : 'No'}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="ticket-exceed-gst-container">
                        <H5 fontWeight={500}>GST applicable on this ticket?</H5>
                        <div className="ticket-name-details-container">
                            <FormControlLabel
                                onChange={(e) =>
                                    formik.setFieldValue('isGstApplicable', e.target.checked)
                                }
                                checked={formik.values.isGstApplicable}
                                disabled={!isEditModeOn}
                                control={<Switch color="main" id="isGstApplicableSwitch" />}
                                label={formik.values.isGstApplicable ? 'Yes' : 'No'}
                            />
                        </div>
                    </div>
                </div>
                <div className="ticket-name-details-container">
                    {formik.values.exceedTicketQty && (
                        <Body3>
                            Sale of tickets will continue after quantity limit has reached.
                        </Body3>
                    )}
                    {!formik.values.exceedTicketQty && (
                        <Body3>Sale of tickets will stop after quantity limit has reached.</Body3>
                    )}
                </div>
            </div>

            {formik.values.isGstApplicable && (
                <div className="ticket-name-details-container">
                    <Autocomplete
                        id="gstRate"
                        options={gstRates}
                        getOptionLabel={(option) => `${option.igst_rate} %`}
                        // value={formik.values.gstRate}
                        value={gstRates?.find((rate) => rate.id === formik.values.gstRate) || null}
                        onChange={(event, newValue) =>
                            formik.setFieldValue('gstRate', newValue?.id)
                        }
                        disabled={!isEditModeOn}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="GST Rate"
                                error={formik.touched.gstRate && Boolean(formik.errors.gstRate)}
                                helperText={formik.touched.gstRate && formik.errors.gstRate}
                            />
                        )}
                    />
                </div>
            )}
        </div>
    );
}

function PriceIcon() {
    return (
        <InputAdornment position="start">
            <CurrencyRupee
                sx={{ paddingLeft: '0.2rem' }}
                color="secondary"
            />
        </InputAdornment>
    );
}

TicketBasicDetail.propTypes = {
    formik: PropTypes.object.isRequired,
    isEditModeOn: PropTypes.bool.isRequired,
    exceedStatusEditable: PropTypes.bool.isRequired,
    qtyEditable: PropTypes.bool.isRequired,
    gstRates: PropTypes.array.isRequired,
};